import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_ITINERARY_FOOD_INVOICE,
  CLEAR_ITINERARY_FOOD_INVOICES,
  FLAG_GETTING_ITINERARY_FOOD_INVOICES,
  FLAG_ITINERARY_FOOD_INVOICE_ACTIVITY,
  GET_ITINERARY_FOOD_INVOICE,
  GET_ITINERARY_FOOD_INVOICES,
} from '../../../actions/types/food/ItineraryFoodInvoice';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_ITINERARY_FOOD_INVOICES:
      return state.setIn(['all', 'loading'], payload);

    case GET_ITINERARY_FOOD_INVOICES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));

    case CLEAR_ITINERARY_FOOD_INVOICES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );

    case FLAG_ITINERARY_FOOD_INVOICE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );

    case GET_ITINERARY_FOOD_INVOICE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));

    case CLEAR_ITINERARY_FOOD_INVOICE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
